/**
 * メイン シーン
 */

import Phaser from 'phaser';
import Review from '../../../../review/main';
import GoodJob from '../../../../goodjob/main';


export default class Game2Clear extends Phaser.Scene{

    constructor(){
        super({key: 'Game2Clear'});
    }


    /**
     * シーン開始時処理 (LifeCycle Methods)
     */
    create(){
        GAME_REF.scene = this;
        this.cameras.main.fadeIn(700, 0, 0, 0);
        this._setDisplay(); 
    }


    /**
     * 描画更新処理 (LifeCycle Methods)
     */
    update(time, delta){
    }

    shutdown() {
        GAME_REF.obj.sound.stopAll();
        this.tweens.killAll();
        this.scene.stop();
        this.scene.remove();
    }

    _setDisplay(){
        this.review = new Review();
        this.goodjob = new GoodJob();
        this.review.render();
    }
}
